/* eslint-disable react/react-in-jsx-scope */
import Viewer, { SpecialZoomLevel, Worker } from "@phuocng/react-pdf-viewer";
import "@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css";
import useText from "constants/text";
import { useFileStyle } from "domains/CashManagement/style";
import { displayFileProps, fileExtension } from "domains/CashManagement/types";
import React from "react";
import { Button } from "ui/Button";
import Dialog from "ui/Dialog";
import { ArrowLeftIcon, ArrowRightIcon, CloseButtonIcon, DownloadFileIcon } from "ui/Icons";


const rowsPerPageLimit = 10;
function DisplayFileDialog({ files, open, onClose }: displayFileProps) {
  const classes = useFileStyle();
  const { text } = useText();
  const [index, setindex] = React.useState(0);

  const getFileExtension = React.useCallback((proof: string) => proof?.split(".")[proof?.split(".").length - 1], [
    files,
  ]);

  const proofs = React.useMemo(
    () =>
      files?.map((file) => {
        return { file, extension: getFileExtension(file) };
      }),
    [files]
  );
  

  const goForward = () => {
    if (index === files?.length - 1) return;
    setindex((prev) => prev + 1);
  };
  const goBack = () => {
    if (index === 0) return;
    setindex((prev) => prev - 1);
  };

  return (
    <Dialog
      open={open}
      handleClose={onClose}
      handleConfirm={() => {}}
      maxWidth="sm"
      removeBottomBar
      hideDialogHeader
      className={classes.dialog}
      dialogActionButtonCustomized
    >
      <div>
        <div className={classes.closeIcon} onClick={onClose}>
          <CloseButtonIcon color="white" />
        </div>

        {index > 0  && 
        <div className={classes.leftArrow} onClick={goBack}>
          <ArrowLeftIcon />
        </div>}

        <div className={classes.container}>
          {files?.length && getFileExtension(proofs[index]?.file) === fileExtension.PDF ? (
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.4.456/build/pdf.worker.min.js">
              <div>
                <Viewer fileUrl={files?.length && proofs[index]?.file} defaultScale={SpecialZoomLevel.ActualSize} />
              </div>
            </Worker>
          ) : (
            <img
              src={files?.length && proofs[index]?.file}
              alt="new"
              className={classes.img}
              height="100%"
              width="100%"
            />
          )}
        </div>

        {index < proofs?.length -1 &&
        <div className={classes.rightArrow} onClick={goForward}>
          <ArrowRightIcon />
        </div>}
        <a href={proofs?.length && proofs[index]?.file} download="proof">
          <Button color="primary" className={classes.downloadButton}>
            <span className="title">
              <DownloadFileIcon />
            </span>
            <p>{text.all.download}</p>
          </Button>
        </a>
      </div>
    </Dialog>
  );
}

export default DisplayFileDialog;
